// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Id from "bs-platform/lib/es6/belt_Id.js";
import * as Belt_Map from "bs-platform/lib/es6/belt_Map.js";
import * as Caml_obj from "bs-platform/lib/es6/caml_obj.js";

var supportedCurrencies = [
  /* USD */0,
  /* INR */1
];

var supportedDurations = [
  /* Hourly */0,
  /* Daily */1,
  /* Weekly */2,
  /* Monthly */3,
  /* Yearly */4
];

var cmp = Caml_obj.caml_compare;

var CurrencyCmp = Belt_Id.MakeComparable({
      cmp: cmp
    });

function makeCurrencyMap(param) {
  return Belt_Map.make(CurrencyCmp);
}

var currencyRate = Belt_Map.make(CurrencyCmp);

var currencyRate$1 = {
  contents: currencyRate
};

export {
  supportedCurrencies ,
  supportedDurations ,
  CurrencyCmp ,
  makeCurrencyMap ,
  currencyRate$1 as currencyRate,
  
}
/* CurrencyCmp Not a pure module */
